import { PropsWithChildren } from 'react';

import { Container, NavBar } from '@/components';
import { PlayerPositionAbbr } from '@/types';
import {
  PLAYER_NAME_SINGULAR_POSITION_BY_ABBREVIATION,
  getValueFromObject,
} from '@/utils';

type Props = PropsWithChildren<{
  positionSelected: PlayerPositionAbbr;
  handleClose: () => void;
}>;

export const ChangePlayer = ({
  children,
  handleClose,
  positionSelected,
}: Props) => {
  return (
    <>
      <NavBar
        mobile={{
          leftContent: {
            displayLogo: true,
          },
          centerContent: { title: 'Cambio' },
          rightContent: {
            customRightAction: () => {
              handleClose();
            },
          },
        }}
      >
        <Container className="flex relative flex-col px-4" variant="fluid">
          <p className="font-medium text-sm mt-4">
            Elegí al{' '}
            {getValueFromObject(
              PLAYER_NAME_SINGULAR_POSITION_BY_ABBREVIATION,
              positionSelected
            )}{' '}
            titular que vas a enviar al banco de suplentes.
          </p>
          {children}
        </Container>
      </NavBar>
    </>
  );
};
